import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

type Intent = 'info' | 'warning';

export const Ribbon = ({ children, intent }: PropsWithChildren<{ intent: Intent }>) => (
    <Wrapper $intent={intent}>{children}</Wrapper>
);

const Wrapper = styled.div<{ $intent: Intent }>`
    padding: 8px 16px;
    border-radius: 3px;
    background-color: ${({ theme, $intent }) =>
        $intent === 'info' ? theme.colors.seafoam0 : theme.container.errorBackground};
    color: ${({ theme, $intent }) => ($intent === 'info' ? theme.colors.seafoam500 : theme.text.negative)};
    border: 1px solid
        ${({ theme, $intent }) => `${$intent === 'info' ? theme.colors.seafoam500 : theme.text.negative}88`};
    flex: 1;
`;
